<template>
  <div class="client_request_device card" v-if="Object.keys(client_request).length > 0 || available_actions.length > 0">
    <div class="client_request_device__header" v-if="Object.keys(client_request).length > 0">
      <router-link :to="'/client_request/' + client_request.id" class="title link">
        <span
            class="mdi"
            :class="select_class(client_request.status).mdi"
            :style="'color:' + select_class(client_request.status).color"
            :title="select_title(client_request.status).label"
        />
        <span> {{ select_type(client_request.type).label }}</span>
        <span> № {{ client_request.id }}</span>
        <span> от {{ date_transform(client_request.date, ".") }}</span>
      </router-link>

      <router-link :to="'/client_request_list?fid=' + device_fid" class="request link">
        <span class="mdi mdi-list-status"></span>
      </router-link>
    </div>

    <div class="response_table" v-if="simcards?.length > 0" ref="info_devices">
      <label>{{ translate('client_request.ordering_devices') }}</label>
      <table>
        <thead>
          <tr>
<!--            <th class="w30" scope="col">-->
<!--              {{ translate('client_request.simcard_list.slot') }}-->
<!--            </th>-->
            <th class="w70" scope="col">
              {{ translate('client_request.simcard_list.oper_name') }}
            </th>
            <th scope="col" class="w35per">
              {{ translate('client_request.simcard_list.iccid') }}
            </th>
            <th scope="col" v-if="$store.getters.getPermissions.permissionGod  === true">
              {{ translate('client_request.simcard_list.status') }}
            </th>
            <th scope="col" class="w100">
              {{ translate('client_request.simcard_list.ts_update') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(simcard, key) in simcards"
            :key="key"
            class="simcard_item link pointer"
            @click="relink(simcard)"
          >
<!--            <td :data-label="translate('client_request.simcard_list.slot')" class="w30">-->
<!--              {{ simcard.slot }}-->
<!--            </td>-->
            <td :data-label="translate('client_request.simcard_list.oper_name')" class="w70">
              {{ simcard.oper_name }}
            </td>
            <td
                class="w35per"
                :data-label="translate('client_request.simcard_list.rmodem_count')"
                :class="search_simcard_in_active(simcard)"
            >
              {{ simcard.iccid }}
            </td>
            <td :data-label="translate('client_request.simcard_list.status')" v-if="$store.getters.getPermissions.permissionGod  === true">
              <span class="badge" :class="global_status_color(+simcard.status)">
                {{ translate(global_status_text(+simcard.status)) }}
              </span>
            </td>
            <td :data-label="translate('client_request.created')" class="w100">
              {{ get_date_short(simcard.ts_update, {day: '2-digit', month: '2-digit', year: '2-digit'}) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="line" style="display:flex; justify-content: center; width: 100%">
      <span
          style="width: 230px;"
          v-for="(action, key) in available_actions"
          :key="key"
          class="btn text-center action"
          @click="client_request_action(action)"
          :style="'background-color:' + action.button_color + '; border-color:' + action.button_color"
      >
        {{ translate("client_request." + action.id) }}
      </span>
    </div>

  </div>

<!--  </div>-->
</template>

<script>

import ClientRequestActivation from "./Modal/Activation/Index.vue";
import ClientRequestDeactivation from "./Modal/Deactivation/Index.vue";
import ClientRequestApprove from "./Modal/Approve/Index.vue";

export default {
  name: "ClientRequestDevice",
  props: [
    "device_fid",
    "device_id",
    "device_name",
    "client_request",
    "available_actions",
    "simcard_list"
  ],
  data() {
    return {

    };
  },

  computed: {
    simcards() {
      return this.client_request ? this.client_request.simcards : [];
    },
  },


  methods: {
    search_simcard_in_active(simcard){
      let active_simcard_list = this.simcard_list.filter((simcard) => {
        return simcard.is_last_in_slot && simcard.slot
      })
      if (active_simcard_list.length > 0){
        let searched_sim = active_simcard_list.find(item => {
          if (item.iccid === simcard.iccid){
            return item
          }
        })
        return searched_sim ? "" : "not_found"
      }
      return ""
    },
    select_title(status){
      let new_status = this.$store.getters.getClientRequestsInfo.statuses.find((entry) => {
        if (entry.id === status){
          return entry
        }
      })
      new_status.label = this.translate("client_request.statuses." + new_status.title)
      return new_status
    },
    select_type(type){
      let new_type = this.$store.getters.getClientRequestsInfo.types.find((entry) => {
        if (entry.id === type){
          return entry
        }
      })
      new_type.label = this.translate("client_request.types." + new_type.title)
      return new_type
    },

    select_class(status){
      let new_status = this.$store.getters.getClientRequestsInfo.statuses.find((entry) => {
        if (status === entry.id) {
          return entry
        }
      })
      if (new_status){
        if (new_status.id === 0){
          new_status.mdi = "mdi-new-box"
        } else if (new_status.id === 1){
          new_status.mdi = "mdi-eye"
        } else if (new_status.id === 2){
          new_status.mdi = "mdi-check-circle"
        } else if (new_status.id === 4){
          new_status.mdi = "mdi-close-circle"
        }
      }

      return new_status
    },
    relink(simcard){
      if (simcard.simcard_profile_id){
        this.$router.push(`/simcard_profile/${simcard.simcard_profile_id}/profile`)
      }
    },
    client_request_action(action){
      switch (action.id) {
        case "activation":
          this.action_activation(action)
          break
        case "deactivation":
          this.action_deactivation(action)
          break
        case "approve":
          this.action_approve(action)
      }
    },
    action_deactivation(){
      let t = this.$createElement(ClientRequestDeactivation, {
        props: {
          device_id: this.device_id,
          text: this.translate('client_request.confirm_deactivation')
        },
        on: {
          close: () => {
            this.$modal.hide('confirm_deactivation')
          },
          update: () => {
            // this.get_client_request_device()
            this.$modal.hide("confirm_deactivation");
          },
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'confirm_deactivation'})

    },
    action_approve(action){
      let t = this.$createElement(ClientRequestApprove, {
        props: {
          device_id: this.device_id,
          device_name: this.device_name,
          device_fid: this.device_fid,
          simcard_count_to_block: action.simcard_count_to_block,
          simcard_mno: action.simcard_mno
        },
        on: {
          close: () => {
            this.$modal.hide("client_request_approve");
          },
          update: () => {
            // this.get_client_request_device()
            this.$modal.hide("client_request_approve");
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
          temp,
          {},
          {
            height: "auto",
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: "client_request_approve",
          }
      );
    },
    action_activation(action){
      let t = this.$createElement(ClientRequestActivation, {
        props: {
          device_id: this.device_id,
          device_name: this.device_name,
          device_fid: this.device_fid,
          initiator_label: action.initiator_label
        },
        on: {
          close: () => {
            this.$modal.hide("client_request_activation");
          },
          update: () => {
            // this.get_client_request_device()
            this.$modal.hide("client_request_activation");
          },
        },
      });
      let temp = {
        render() {
          return t;
        },
      };
      this.$modal.show(
          temp,
          {},
          {
            height: "auto",
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: "client_request_activation",
          }
      );
    }
  },
};
</script>
<style lang='scss' scoped>
.client_request_device{
  padding: 10px;
  margin-bottom: 10px;
  font-size: inherit;
  &__header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  & .title{
    display: flex;
    align-items: center;
    font-size: 18px;
    line-height: 120%;
    font-weight: bold;
    flex-wrap: wrap;
    &:hover {
      color: #3091B2;
    }
    span{
      margin-right: 5px;
      white-space: nowrap;
      &.mdi{
        font-size: 26px;
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
  .request{
    //width: 100%;
    font-size: 24px;
    line-height: 100%;
    text-align: right;
  }
  .line{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 10px;
    &:last-child{
      margin-bottom: 0;
    }
    .input{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
      label{
        font-size: 12px;
        color: #252422;
        font-weight: bold;
        margin-bottom: 5px;
      }
    }
    .btn{
      width: 100%;
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .action{
      color: white;
      &:hover{
        filter: brightness(80%)
      }
    }
    .form-group{
      .form-control{
        padding: 5px;
      }
    }
  }
  .response_table{
    padding: 0;
    margin-bottom: 10px;
    .oper_name{
      min-width: 70px;
    }

    td {
      .badge {
        font-size: 10px;
      }
    }
    .simcard_item{
      color: #66615b;
      &:hover{
        background-color: #eee;
      }
      .not_found{
        background-color: #b8414130;
      }
    }
  }
}


</style>
